export default "__VITE_ASSET__34055bf3__"